
import Model from "@/models/yunMobile";
import Icon from 'vux/src/components/icon/index.vue'

import { mapActions } from "vuex";
import loadScript from "@/config/loadScript";
import requestBasicUrl from "@/config/anboUrl";
import { debounce } from "@/utils/throttleDebounce";
export default {
components: {
Icon
},
data() {
return {
formData: {
tel: "",
parkNo: this.$route.params.parkNo,
passNo: this.$route.params.passid,
cardCode:this.$route.query.cardCode
},
appid: "",
parkId: "",
domIsvalid: true,
domText: "",
Loading:false
};
},
methods: {
...mapActions("yunMobile", {
sendPhone: "setCarinBranchAction"
}),
_submit() {
this.Loading = true;
if (!/^1[3-9]\d{9}$/.test(this.formData.tel)) {
this.$layer.msg("请输入正确的手机号码");
this.Loading = false;
return;
}

sessionStorage.setItem("isNoCar", 1);

if (this.$route.query.pay == 1) {
let _data = {
passNo: this.formData.passNo,
parkNo: this.formData.parkNo,
carNo: this.formData.tel.replace(/\s+/g, "")
};
this.sendPhone(_data).then(res => {
if (!res.list.nopay) {
sessionStorage.setItem('isEnterPhone',true);
this.$router.push({ path: `/mobile/yunMobile/confirmPay/2?cardCode=${this.formData.cardCode}` });
} else {
setTimeout(() => {
location.reload();
}, 2000);
}
this.Loading=false
}).catch(()=>{
this.Loading=false
})
} else {

this.openPark();
}
},
submit: debounce(function() {
this._submit();
}, 1000),
async openPark() {
let { data } = await Model.openParkByPhone(this.formData);
this.formData.tel = "";
this.Loading = false;
}
},
created() {
localStorage.setItem('cardCode',this.$route.query.cardCode)
if(this.$route.query.pay !== '1'){
Model.checkcode({parkNo:this.formData.parkNo,nocardCode:this.formData.cardCode,codeType:2}).then(res=>{
if (res.data.success) {
this.domIsvalid = true;
} else {
this.domText = res.data.error;
this.domIsvalid = false;
}
})
}else{
this.domIsvalid=true
}
let tel = localStorage.getItem("carNo");
if (!isNaN(tel)) {
this.formData.tel = tel;
}
},

mounted() {
Model.zuijiao({
passNo: this.formData.passNo,
parkNo: this.formData.parkNo
}).then(res => {
if(res.data.msg.slice(-2)==="-1"){
this.domIsvalid = false;
this.domText= res.data.msg.slice(0,res.data.msg.length-3);
return
} else if (res.data.msg!=='无追缴信息,1') {
this.$store.commit("yunMobile/setCarin",  res.data.list );
sessionStorage.setItem('showbtn',false)
sessionStorage.setItem('isEnterPhone',true);
this.$router.push({ path: `/mobile/yunMobile/confirmPay/2?showbtn=false&cardCode=${this.formData.cardCode}` });
}
});




























}
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/branch/enterPhone.vue